import { z } from "zod"

const veNftV4Item = z.object({
  id: z.number(),
  lockAmount: z.string(),
  lockEnds: z.number(),
  lockValue: z.string(),
  isMaxLocked: z.boolean(),
  hasExpired: z.boolean(),
  isReset: z.boolean(),
  hasVotes: z.boolean(),
  hasVotedThisEpoch: z.boolean(),
  lastVoted: z.number(),
  needsResetToWithdraw: z.boolean(),
  canWithdraw: z.boolean(),
})

export const veNftV4ResponseSchema = z.array(veNftV4Item)

export type NftV4Response = z.infer<typeof veNftV4ResponseSchema>
export type NftV4ResponseItem = NftV4Response[number]
